// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"4f146ae1","316":"90406a5b","641":"50e0f4a9","865":"70328a36","989":"2d249920"}[chunkId] + ".chunk.js";
};